import React from 'react';

/* ─── STUDIO SET ──────────────────────────────────────────────────────────
   The foreground the lens passes.

   The services themselves are photographic renders, so the set around them is
   a studio rather than a place: contentless, there to hold light and to carry
   rate. Drawing cartoon scenery next to a photographic render made the render
   look pasted on, and the drawing is what the eye judged the frame by.

   Depth still comes from the reference's rule — near things crossing the whole
   frame while far things barely move. This is the near end of that: thin
   streaks and out-of-focus specks at 1.72x, the one layer still travelling
   sideways, so there is always something crossing between one service rising
   and the next.
   ───────────────────────────────────────────────────────────────────────── */

/* Deterministic, because these are re-rendered on every resize and a set that
   reshuffles itself under the reader is worse than no variation at all. */
function rng(seed) {
  let s = (seed * 2654435761) >>> 0;
  return () => {
    s = (s * 1664525 + 1013904223) >>> 0;
    return s / 4294967296;
  };
}

/* Backdrop flats, kept for the far strip if it is ever wanted back. The
   sector's own place is the middle distance now, so nothing mounts this. */
export function SetFar({ index }) {
  const rnd = rng(index + 11);
  const slabs = [0, 1, 2, 3].map(i => {
    const w = 90 + rnd() * 150;
    const h = 190 + rnd() * 250;
    return { x: -300 + i * 175 + rnd() * 40, w, h, o: 0.5 + rnd() * 0.5 };
  });
  return (
    <>
      {slabs.map((s, i) => (
        <rect key={i} x={s.x} y={-s.h} width={s.w} height={s.h}
          rx="10" opacity={s.o.toFixed(2)} />
      ))}
    </>
  );
}

/* What the lens passes at 1.72x. Abstract on purpose: anything recognisable
   this close to the camera competes with the subject instead of framing it. */
export function SetNear({ index }) {
  const rnd = rng(index + 97);
  return (
    <>
      <rect className="zx-set__streak" x="-4" y="-330" width="7" height="330" rx="3.5" />
      <rect className="zx-set__streak" x="118" y="-240" width="5" height="240" rx="2.5"
        opacity="0.7" />
      <rect className="zx-set__streak" x="-150" y="-186" width="4" height="186" rx="2"
        opacity="0.55" />
      {[0, 1, 2, 3, 4].map(i => {
        const r = 4 + rnd() * 11;
        return (
          <circle key={i} className="zx-set__speck"
            cx={-190 + rnd() * 420} cy={-40 - rnd() * 300} r={r.toFixed(1)}
            opacity={(0.18 + rnd() * 0.3).toFixed(2)} />
        );
      })}
    </>
  );
}
